export const PROFILE_HEADER_VISIBILITY_EVENT = "profile-header-visibility" as const;
export const PROFILE_STICKY_COMPACT_EVENT = "profile-sticky-compact" as const;

export function dispatchProfileHeaderVisibility(visible: boolean) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(PROFILE_HEADER_VISIBILITY_EVENT, { detail: { visible } })
  );
}

export function dispatchProfileStickyCompact(visible: boolean) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(PROFILE_STICKY_COMPACT_EVENT, { detail: { visible } })
  );
}
